import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { invoiceKeys, receiptKeys } from '@/lib/queryKeys';
import { billingV2Post } from '@/lib/api/clients/billing-v2';
import { billingV2Endpoints } from '@/lib/api/endpoints';
import type { RecordPaymentDto } from '@/types/invoice';
import { invalidateInvoicePaymentViews } from './invalidateInvoicePaymentViews';

export function useRecordPayment() {
  const queryClient = useQueryClient();

  return useApiMutation<Record<string, unknown>, RecordPaymentDto>({
    mutationFn: async (body) =>
      billingV2Post<Record<string, unknown>, RecordPaymentDto>(
        billingV2Endpoints.paymentCreate(),
        body,
      ),
    // useApiMutation toasts the server's reason. A generic line on top of it
    // buried why a payment was refused (a bank payment still clearing).
    onSuccess: (_data, dto) => {
      void queryClient.invalidateQueries({ queryKey: receiptKeys.all() });
      void queryClient.invalidateQueries({
        queryKey: invoiceKeys.detail(dto.invoiceId),
      });
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.lists() });
      void queryClient.invalidateQueries({
        queryKey: [...invoiceKeys.detail(dto.invoiceId), 'payments'],
      });
      void invalidateInvoicePaymentViews(queryClient);
      toast.success('Payment recorded');
    },
  });
}
